import { Outlet } from 'react-router-dom';

/** Router root — deliberately empty chrome.
 *
 *  The shell used to live here, which meant the login and accept-invite screens
 *  rendered inside the app frame (sidebar and all). Now the chrome belongs to the
 *  shells: unauthenticated screens render bare, and everything behind
 *  ProtectedRoute mounts either CustomerShell or AdminShell.
 *
 *  Login is the one screen both audiences share; from there the role decides which
 *  shell they land in. */
export default function App() {
  return <Outlet />;
}
